import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { Backend } from "../../types/backend";
import { fetchFileInfo } from "./file-info";
import { fromFileInfoResp } from "./from-file-info-resp";
export function fetchDriveFile(_x) {
  return _fetchDriveFile.apply(this, arguments);
}
function _fetchDriveFile() {
  _fetchDriveFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(req) {
    var _yield$fetchFileInfo, data, error;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetchFileInfo(req);
        case 2:
          _yield$fetchFileInfo = _context.sent;
          data = _yield$fetchFileInfo.data;
          if (!(data.retcode !== Backend.RetCode.SUCCESS)) {
            _context.next = 8;
            break;
          }
          error = new Error('请求 fileInfo 接口失败'); // @ts-ignore;
          error.data = data;
          throw error;
        case 8:
          return _context.abrupt("return", fromFileInfoResp(data));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchDriveFile.apply(this, arguments);
}
//# sourceMappingURL=fetch-drive-file.js.map